export default __webpack_public_path__ + "static/media/imgHecesFecales.04454d13.png";